<div class="modal-header cir-modal-header">
  <div class="cir-header-left">
    <div class="cir-header-icon">
      <i class="fa fa-phone"></i>
    </div>
    <div class="cir-header-title">
      <h4 class="modal-title">CALLER INFORMATION REPORT</h4>
      <div class="cir-title-underline"></div>
    </div>
  </div>
  <div class="cir-header-right">
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>

<div class="modal-body">

  <!-- Summary chips -->
  <div class="cir-summary-bar">
    <div class="cir-chip-sep"></div>
    <div class="cir-summary-chip">
      <div class="cir-chip-icon"><i class="fa fa-id-badge"></i></div>
      <div>
        <div class="cir-chip-label">Call ID :</div>
        <div class="cir-chip-value">{{ callId || '' }}</div>
      </div>
    </div>
    <div class="cir-chip-sep"></div>
    <div class="cir-summary-chip">
      <div class="cir-chip-icon"><i class="fa fa-user-circle"></i></div>
      <div>
        <div class="cir-chip-label">Caller ID :</div>
        <div class="cir-chip-value">{{ callerDetails?.caller_id || '' }}</div>
      </div>
    </div>
    <div class="cir-chip-sep"></div>
    <div class="cir-summary-chip">
      <div class="cir-chip-icon"><i class="fa fa-phone"></i></div>
      <div>
        <div class="cir-chip-label">Calling No :</div>
        <div class="cir-chip-value">{{ mobileNo  }}</div>
      </div>
    </div>
  </div>

  <!-- Details -->
  <div class="cir-info-block">

    <div class="cir-info-row">
      <div class="cir-info-pair">
        <span class="cir-lbl">Mobile Number :</span>
        <span class="cir-val">{{ caseData?.mobile_number || caseData?.mobile || '—' }}</span>
      </div>
      <div class="cir-info-pair">
        <span class="cir-lbl">Caller Type :</span>
        <span class="cir-val">{{ caseData?.caller_type?.caller_type || caseData?.callerType || '—' }}</span>
      </div>
      <div class="cir-info-pair">
        <span class="cir-lbl">Call Type :</span>
        <span class="cir-val">{{ caseData?.call_type?.call_type || caseData?.callType || '—' }}</span>
      </div>
      <div class="cir-info-pair">
        <span class="cir-lbl">Request For :</span>
        <span class="cir-val">{{ caseData?.request?.request_for || caseData?.request_for || '—' }}</span>
      </div>
    </div>

    <div class="cir-info-row">
      <div class="cir-info-pair">
        <span class="cir-lbl">First Name :</span>
        <span class="cir-val">{{ caseData?.first_name || '—' }}</span>
      </div>
      <div class="cir-info-pair">
        <span class="cir-lbl">Middle Name :</span>
        <span class="cir-val">{{ caseData?.middle_name || '—' }}</span>
      </div>
      <div class="cir-info-pair">
        <span class="cir-lbl">Last Name :</span>
        <span class="cir-val">{{ caseData?.last_name || '—' }}</span>
      </div>
      <div class="cir-info-pair">
        <span class="cir-lbl">Gender :</span>
        <span class="cir-val">{{ caseData?.gender?.gender || caseData?.genderName || '—' }}</span>
      </div>
    </div>

    <div class="cir-info-row">
      <div class="cir-info-pair">
        <span class="cir-lbl">State :</span>
        <span class="cir-val">{{ caseData?.state?.state_name || caseData?.stateName || '—' }}</span>
      </div>
      <div class="cir-info-pair">
        <span class="cir-lbl">District :</span>
        <span class="cir-val">{{ caseData?.district?.district_name || caseData?.districtName || '—' }}</span>
      </div>
      <div class="cir-info-pair">
        <span class="cir-lbl">Mandal :</span>
        <span class="cir-val">{{ caseData?.mandal?.mandal_name || caseData?.mandalName || '—' }}</span>
      </div>
      <div class="cir-info-pair">
        <span class="cir-lbl">Village :</span>
        <span class="cir-val">{{ caseData?.village?.village_name || caseData?.villageName || '—' }}</span>
      </div>
    </div>

    <div class="cir-info-row">
      <div class="cir-info-pair">
        <span class="cir-lbl">Latitude :</span>
        <span class="cir-val">{{ caseData?.latitude ? (caseData.latitude + '° N') : '—' }}</span>
      </div>
      <div class="cir-info-pair">
        <span class="cir-lbl">Longitude :</span>
        <span class="cir-val">{{ caseData?.longitude ? (caseData.longitude + '° E') : '—' }}</span>
      </div>
      <div class="cir-info-pair"></div>
      <div class="cir-info-pair"></div>
    </div>

    <div class="cir-info-row cir-info-row-full">
      <div class="cir-info-pair">
        <span class="cir-lbl"><i class="fa fa-map-marker" style="color:#1565c0"></i> Address :</span>
        <span class="cir-val">{{ caseData?.address || '—' }}</span>
      </div>
    </div>

    <div class="cir-info-row cir-info-row-full">
      <div class="cir-info-pair">
        <span class="cir-lbl"><i class="fa fa-comment" style="color:#1565c0"></i> Remarks :</span>
        <span class="cir-val">{{ caseData?.remarks || '—' }}</span>
      </div>
    </div>

  </div>

   <div class="row">
                            <div class="table-responsive">
                                <table datatable [dtOptions]="dtOptions" *ngIf="dtRender"
                                    class="table table-striped table-bordered table-sm" style="width: 100%;">
                                    <thead>
                                        <tr>
                                           <th>S.No</th>
                                           <th *ngIf="Is1962LiveStock">Farmer Name</th>
                                           <th *ngIf="EnableHumanMMU">Patient Name</th>
                                           <th *ngIf="EnableHumanMMU">Age</th>
                                           <th *ngIf="EnableHumanMMU">Gender</th>
                                           <th *ngIf="EnableHumanMMU">Patient Mobile No</th>
                                           <th class="singleLine" *ngIf="Is1962LiveStock">Farmer Mobile No</th>
                                           <th>Call ID</th>
                                           <th>Case Number</th>
                                           <th>Latitude</th>
                                           <th>Longitude</th>
                                           <th *ngIf="Is1962LiveStock">Animal</th>
                                           <th class="singleLine" *ngIf="Is1962LiveStock">Breed Type</th>
                                           <th>Vehicle No</th>
                                           <th>Mapped Vehicle Mobile No</th>
                                           <th>Case Registered Date & Time</th>
                                           <th>Assigned Date & Time</th>
                                           <!-- <th>Gender</th> -->
                                           <th>Status</th>
                                           <th>Action</th>
    
    
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let item of lstGrid;let i=index;">
                                            <td>{{i+1}}</td>
                                            <td *ngIf="Is1962LiveStock">{{item?.farmer_name}}</td>
                                            <td *ngIf="EnableHumanMMU">{{item?.patient_name}}</td>
                                            <td *ngIf="EnableHumanMMU">{{item?.age}}</td>
                                            <td *ngIf="EnableHumanMMU" >{{item?.patient_gender}}</td>
                                            <td *ngIf="EnableHumanMMU">{{item?.mobile_number}}</td>
                                            <td class="singleLine" *ngIf="Is1962LiveStock">{{item?.farmer_mobile_number}}</td>
                                            <td>{{item?.call_uuid }}</td>
                                            <td>{{item?.case_number}}</td>
                                            <td>{{item?.latitude}}</td>
                                            <td>{{item?.longitude}}</td>
                                            <td *ngIf="Is1962LiveStock">{{item?.animal_type}}</td>
                                            <td class="singleLine" *ngIf="Is1962LiveStock">{{item?.breed_type}}</td>
                                            <td class="singleLine">{{item?.vehAndMvu}}</td>
                                            <td>{{item?.mobile_no}}</td>
                                            <td>{{item?.created_on }}</td>
                                            <td>{{item?.assigned_date}}</td>
                                            <!-- <td>{{item?.gender}}</td> -->
                                            <td>{{item?.status}}</td>
                                                <td style="display:inline-flex !important; width:100% !important" style="text-wrap: nowrap;">
                                                    <button class="btn btn-sm btn-primary" style="text-wrap: nowrap;" [attr.disabled]="item?.status=='Closed'?true : null" (click)="openPoc(item)" *ngIf="isDoctor && (item?.status == 'Pending' || item?.status == 'Vehicle Assigned' || item?.status == 'Accepted' 
                                                    || item?.status == 'Vehicle started to case location' || item?.status == 'Vehicle reached to case location')">POC</button>&nbsp;&nbsp;
                                                    <!-- <button class="btn btn-sm btn-primary" style="text-wrap: nowrap;" [attr.disabled]="(item?.status=='Pending'?null : true || item?.status=='Vehicle Assigned'?null : true)" (click)="openSpeciesModel(item)" *ngIf="(item?.status == 'Pending' || item?.status=='Vehicle Assigned') && Is1962LiveStock">Add animals</button>&nbsp;&nbsp; -->
                                                    <!-- <button class="btn btn-sm btn-primary" style="text-wrap: nowrap;" [attr.disabled]="(item?.status=='Pending'?null : true || item?.status=='Vehicle Assigned'?null : true)" (click)="animalImages(item)" *ngIf="(item?.status == 'Completed') && Is1962LiveStock">Treated Animal Images</button>&nbsp;&nbsp; -->
                                                    <!-- <button class="btn btn-sm btn-primary" data-toggle="modal"
                                                        data-target="#assignVehicles" style="text-wrap: nowrap;" [attr.disabled]="(item?.status=='Closed'?true : null) || (item?.status=='Completed'?true : null)" (click)="assignVehicle(item)" *ngIf="!isDoctor">{{item?.mvu_id == null ? 'Assign Vehicle' : 'Re-Assign Vehicle'}}</button>&nbsp;&nbsp; -->
                                                    <!-- <button class="btn btn-sm btn-primary" data-toggle="modal"
                                                        data-target="#unavail" style="text-wrap: nowrap;" [attr.disabled]="item?.status=='Closed'?true : null" (click)="unAvailedPopup(item)" *ngIf="!isDoctor">Unavailed</button>&nbsp;&nbsp; -->
                                                        <!-- <button class="btn btn-sm btn-primary" style="text-wrap: nowrap;" [attr.disabled]="item?.status=='Closed'?true : null" *ngIf="!isDoctor" >Call</button>&nbsp;&nbsp; -->
                                                        <!-- <button class="btn btn-sm btn-danger" style="text-wrap: nowrap;" [attr.disabled]="item?.status=='Closed'?true : null" *ngIf="!isDoctor && (item?.status=='Unavailed' || item?.status=='Completed')" (click)="closeButton(item)">Close</button> -->
                                                </td>
                                            
    
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>


</div>
